import { useClientConfig } from '@framework/auth/client-config/ClientConfigSlice.tsx';
import { type BaseMenuItemsProps } from '@framework/theme/front/useAdditionalFrontMenuItems.ts';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook che permette di aggiungere voci al menu di navigazione.
 */
export function useAdditionalFrontMenuItems(): BaseMenuItemsProps[] {
  const { t } = useTranslation();
  const { enablePublicArea, applicationConfig } = useClientConfig();
  const canVerifyPass = applicationConfig?.flVerificaAlbo ?? false;

  const additionalFrontMenuItems: BaseMenuItemsProps[] = [];

  if (enablePublicArea) {
    additionalFrontMenuItems.push({
      menuKey: 'area-pubblica',
      to: '/area-pubblica',
      children: t('menu.area-pubblica', 'Area Pubblica'),
      title: t('menu.area-pubblica.sr-title', 'Vai a Area Pubblica'),
    });
  }
  if (process.env.BUILD_FLAGS_VERIFY_PASS && canVerifyPass) {
    additionalFrontMenuItems.push({
      menuKey: 'verifica-tesserini',
      to: '/verifica-tesserini',
      children: t('menu.verifica-tesserini', 'Verifica Tesserini'),
      title: t('menu.verifica-tesserini.sr-title', 'Vai a Verifica Tesserini'),
    });
  }

  return additionalFrontMenuItems;
}
